var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons=Upload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.0625 15.875V7.8125L8.5125 10.3625L7.2125 9.0375L12 4.25L16.7875 9.0375L15.4875 10.3625L12.9375 7.8125V15.875H11.0625ZM4.25 19.75V14.9375H6.125V17.875H17.875V14.9375H19.75V19.75H4.25Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/icon-upload.16a1f2fcfd20df3f0635a66b14e510ad.svg";
export { ForwardRef as ReactComponent };